/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Editemail_Validation_Required2Inputs */

const en_coinvestments_editemail_validation_required2 = /** @type {(inputs: Coinvestments_Editemail_Validation_Required2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email text is required`)
};

/**
* | output |
* | --- |
* | "Email text is required" |
*
* @param {Coinvestments_Editemail_Validation_Required2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_editemail_validation_required2 = /** @type {((inputs?: Coinvestments_Editemail_Validation_Required2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Editemail_Validation_Required2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_editemail_validation_required2(inputs)
});
export { coinvestments_editemail_validation_required2 as "coInvestments_editEmail_validation_required" }